import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Endpoints, Mutations, Actions } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'RolesAndPermissions', namespaced: true})
export default class RolesAndPermissions extends VuexModule {
    public rolesAndPermissions: any[] = [];
    public allFeatures: any[] = [];
    public currentEditRole: any = [];

    @Mutation
    public RESET_ROLES_AND_PERMISSIONS() {
        this.rolesAndPermissions = [];
        this.allFeatures         = [];
        this.currentEditRole     = [];
    }

    get getRolesAndPermissions() {
        return this.rolesAndPermissions;
    }

    get getAllFeatures() {
        return this.allFeatures;
    }

    get getCurrentEditRole() {
        return this.currentEditRole;
    }

    get getRole() {
        return (roleId: number) => {
            return this.rolesAndPermissions.find((role: any) => role.id === roleId);
        };
    }

    @Action
    public FETCH_PERMISSION_ROLES() {
        axios.get(Endpoints.Admin.Roles.PERMISSION_ROLES)
            .then((response: any) => {
                store.commit(Mutations.SET_PERMISSION_ROLES, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public FETCH_PERMISSION_FEATURES() {
        axios.get(Endpoints.Admin.Roles.PERMISSION_FEATURES)
            .then((response: any) => {
                store.commit(Mutations.SET_PERMISSION_FEATURES, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public TOGGLE_PERMISSION_ROLE_FEATURE(data: any) {
        const requestPayload = new FormData();

        requestPayload.append('permission', data.permission);
        requestPayload.append('featureId', data.featureId);

        axios.post(Endpoints.Admin.Roles.TOGGLE_PERMISSION_ROLE_FEATURE(data.roleId), requestPayload)
            .then((response) => {
                store.commit(Mutations.SET_TOGGLED_PERMISSION_ROLE_FEATURE, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public ADD_NEW_ROLE(data: any) {
        const requestPayload = new FormData();

        requestPayload.append('name', data.name);
        requestPayload.append('description', data.description);
        requestPayload.append('key', data.key);
        requestPayload.append('staff', data.staff);
        requestPayload.append('visible', data.visible);

        axios.post(Endpoints.Admin.Roles.ADD_ROLE, requestPayload)
            .then((response) => {
                store.commit(Mutations.ADD_TO_ROLE_LIST, response.data);
                store.dispatch(Actions.HIDE_FORM);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public EDIT_CURRENT_ROLE(data: any) {
        const requestPayload = new FormData();

        requestPayload.append('name', data.name);
        requestPayload.append('description', data.description);
        requestPayload.append('staff', data.staff);
        requestPayload.append('visible', data.visible);

        axios.put(Endpoints.Admin.Roles.EDIT_ROLE(data.id), requestPayload)
            .then((response) => {
                store.commit(Mutations.UPDATE_CURRENT_ROLE, response.data);
                store.dispatch(Actions.HIDE_FORM);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Mutation
    public SET_PERMISSION_ROLES(data: any) {
        this.rolesAndPermissions = data;
    }

    @Mutation
    public SET_PERMISSION_FEATURES(data: any) {
        this.allFeatures = data;
    }

    @Mutation
    public SET_TOGGLED_PERMISSION_ROLE_FEATURE(data: any) {
        const role = this.rolesAndPermissions.find((rl: any) => rl.id === data.id);
        role.featureIds = data.featureIds;
        role.defaultFeatureIds = data.defaultFeatureIds;
    }

    @Mutation
    public UPDATE_CURRENT_ROLE(data: any) {
        const role = this.rolesAndPermissions.find((rl: any) => rl.id === data.id);
        role.name = data.name;
        role.description = data.description;
        role.isStaff = data.isStaff;
        role.visible = data.visible;
    }

    @Mutation
    public SET_CURRENT_EDIT_ROLE(role: any) {
        this.currentEditRole = role;
    }

    @Mutation
    public ADD_TO_ROLE_LIST(data: any) {
        this.rolesAndPermissions.push(data);
    }
}
